import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatPseudoCheckboxModule } from "@angular/material/core";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppButtonModule } from './../dave-utils-module/app-button-module/app-button.module';
import { SmallFileCardComponent } from './small-file-card.component';

@NgModule({
    declarations: [SmallFileCardComponent],
    imports: [CommonModule, FontAwesomeModule, MatButtonModule, AppButtonModule, MatTooltipModule, MatPseudoCheckboxModule],
    exports: [SmallFileCardComponent],
})
export class SmallFileCardModule {}
